export default __webpack_public_path__ + "static/media/23.448d3c0c.png";